module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House01.11b3abac.jpg";